import React from 'react'

import { useNavigate } from 'react-router-dom'

import CourseCard from './CourseCard'
import LearningResourceCard from './LearningResourceCard'
import { learningResources } from './learningResources'
import { useUser } from '../../../../context'
import { Section } from '../../../_components'
import { LearningResourcesGrid, LearningStatus } from '../styles'

import type { CourseSummary } from './types'

interface LearningPathProps {
  courses: CourseSummary[]
  loading?: boolean
}

const LearningPath = ({ courses, loading = false }: LearningPathProps) => {
  const navigate = useNavigate()
  const { user } = useUser()
  const dropboxLink =
    user && 'dropboxLink' in user && typeof user.dropboxLink === 'string'
      ? user.dropboxLink
      : undefined

  const openResource = (resource: (typeof learningResources)[number]) => {
    if (resource.destination === 'dropbox') {
      if (dropboxLink) {
        window.open(dropboxLink, '_blank', 'noopener,noreferrer')
      }
      return
    }

    navigate(resource.destination === 'routine' ? '/rutina' : '/chat')
  }

  const hasCourses = courses.length > 0
  const sectionActionProps = hasCourses
    ? {
        actionLabel: 'Ver toda la ruta',
        onAction: () => navigate('/ruta-formacion'),
      }
    : {}

  return (
    <Section
      title="Tu ruta de aprendizaje"
      subtitle="Continúa exactamente donde lo dejaste."
      {...sectionActionProps}
    >
      <>
        <LearningResourcesGrid>
          {learningResources.map((resource) => {
            const unavailable =
              resource.destination === 'dropbox' && !dropboxLink

            return (
              <LearningResourceCard
                key={resource.id}
                resource={resource}
                unavailable={unavailable}
                onOpen={openResource}
              />
            )
          })}
          {courses.slice(0, 1).map((course) => (
            <CourseCard key={course.id} course={course} />
          ))}
        </LearningResourcesGrid>

        {loading && (
          <LearningStatus role="status">Cargando cursos…</LearningStatus>
        )}
        {!loading && !hasCourses && (
          <LearningStatus>
            Todavía no tenés cursos asignados. Mientras tanto podés entrar a tu
            rutina, revisar grabaciones disponibles o escribirle al equipo.
          </LearningStatus>
        )}
      </>
    </Section>
  )
}

export default LearningPath
